import { render, staticRenderFns } from "./StackBarChart.vue?vue&type=template&id=875c195c&"
import script from "./StackBarChart.vue?vue&type=script&lang=js&"
export * from "./StackBarChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports